import { Button, Label, Spinner, TextInput, Textarea } from 'flowbite-react';
import React from 'react';
import { UseMutationResult } from 'react-query';
import Select, { SingleValue } from 'react-select';
import { Dropdown, mapPositionTitlesToDropdownOptions } from 'shared-utils';
import { BaseAPIResponse, RejectActionForApplicationInput, UIRemarksDrawerType } from 'types';
import { useGetPositionTitlesQuery } from '../../../hooks/positionConfiguration.hooks';

interface Props {
	ctaText?: string;
	type: string;
	handleSubmit?: () => void;
	isLoading?: boolean;
	remarks?: string;
	setRemarks?: (arg: string) => void;
	designationTitle?: string;
	setDesignationTitle?: (arg: string) => void;
	ctc?: number;
	setCtc?: (arg: number) => void;
	remarksDrawerType?: UIRemarksDrawerType;
	jobseekerOptOutRemarks?: string;
	showApproveRejectOptions?: boolean;
}

const RemarksDrawer = ({
	remarksDrawerType,
	isLoading,
	ctaText,
	type,
	handleSubmit,
	remarks,
	setRemarks,
	designationTitle,
	setDesignationTitle,
	ctc,
	setCtc,
	jobseekerOptOutRemarks,
}: Props) => {
	const { data: positionTitlesData, isLoading: isLoadingPositionTitles } = useGetPositionTitlesQuery();
	if (!remarksDrawerType || !handleSubmit || !setRemarks) {
		return;
	}
	return (
		<div className="grid gap-[12px]">
			{[UIRemarksDrawerType.SEND_OFFER_LETTER_CHANGES, UIRemarksDrawerType.SEND_OPT_OUT_OFFER_CHANGES].includes(
				remarksDrawerType,
			) && (
					<>
						{jobseekerOptOutRemarks && (
							<div className="mb-[16px] border border-[#C7C9D933] dark:bg-[#18222D] bg-[#E5F0FF] mt-[14px] rounded-[4px] p-[10px]">
								<p className="text-[#555770]">
									<span className="text-[#FF3B3B]">Comments: </span>
									{jobseekerOptOutRemarks}
								</p>
							</div>
						)}
						{/* CTC */}
						<div>
							<div className="mb-[8px]">
								<Label>{'CTC offered (in INR):'}</Label>
							</div>

							<TextInput
								name="ctc"
								type="number"
								step={1}
								min={0}
								value={ctc}
								placeholder="500000"
								className=" bg-white dark:text-white dark:border-[#4B5563] rounded-lg dark:bg-[#374151] focus:border-transparent focus:!ring-[1px] focus:!ring-[#7777E7]"
								onChange={e => {
									setCtc && setCtc(Number(e.target.value));
								}}
							></TextInput>
						</div>

						{/* Designation Offered */}
						<div>
							<div className="mb-[8px]">
								<Label>{'Designation offered:'}</Label>
							</div>

							<Select
								options={mapPositionTitlesToDropdownOptions(positionTitlesData?.positionTitles)}
								isLoading={isLoadingPositionTitles}
								menuPlacement={'auto'}
								classNamePrefix="my-select-plans"
								className="single-value-select-tag"
								onChange={(val: SingleValue<Dropdown>) => {
									setDesignationTitle && setDesignationTitle(val?.label ?? '');
								}}
								placeholder="SDE-1"
							/>
						</div>
					</>
				)}
			<div className="block">
				<div className="mb-[8px] flex justify-between items-end">
					<div>
						<Label>{'Your message '}</Label>
						<span className="text-[red]">*</span>
					</div>

					<span className="italic text-xs text-[#6B7280] ">{remarks?.length + ' / ' + 640}</span>
				</div>
				<Textarea
					name="message"
					placeholder="Write message here ..."
					value={remarks}
					maxLength={640}
					onChange={e => {
						setRemarks(e.target.value);
					}}
					className="border bg-white dark:text-white dark:border-[#4B5563] min-h-[100px] dark:bg-[#374151] focus:border-transparent focus:!ring-[1px] focus:!ring-[#7777E7]"
				/>
			</div>
			<Button
				disabled={isLoading}
				onClick={() => {
					handleSubmit();
				}}
				className="mt-[16px] mx-auto"
				color="purplePlaced"
			>
				{isLoading ? <Spinner /> : ctaText}
			</Button>
		</div>
	);
};

export default RemarksDrawer;
